import React from 'react';
import { RouteFormatter } from '../../routes';
import { SPOT_SRC_MEMBERSHIP } from '../../consts/spot-src';
import SvgCheck from 'src/assets/svg/SvgCheck.svg';
import SvgCross from 'src/assets/svg/SvgCross.svg';
import './why-rent.scss';

const MIN_SPOTS_APPEREANCES = 2;
const MIN_STATS_SHOWN = 3;
const MAX_STATS_SHOWN = 6;

const stats = ({
    data,
    cityQ,
    subWaterPage,
    subFencedPage,
    subHikingPage,
    subAgilityPage,
    subFieldPage,
    subSmallPage,
    subBeachPage,
    subIndoorPage,
}) => [
    {
        title: 'total dog parks',
        count: data?.totalSpots || 0,
        isSubPage: false,
        link: encodeURI(
            RouteFormatter.listings(
                {},
                {
                    query: {
                        loc: cityQ,
                        lat: data.latitude || undefined,
                        lng: data.longitude || undefined,
                    },
                }
            )
        ),
    },
    {
        title: 'dog water parks',
        count: data?.waterSpotsCount || 0,
        isSubPage: subWaterPage,
        link: subWaterPage
            ? RouteFormatter.listings({ first: subWaterPage.url })
            : encodeURI(
                  RouteFormatter.waterListings(null, {
                      query: {
                          loc: cityQ,
                          lat: data.latitude || undefined,
                          lng: data.longitude || undefined,
                      },
                  })
              ),
    },
    {
        title: 'fully fenced dog parks',
        count: data?.fullyFencedCount || 0,
        isSubPage: subFencedPage,
        link: subFencedPage
            ? RouteFormatter.listings({ first: subFencedPage.url })
            : encodeURI(
                  RouteFormatter.fencedListings(null, {
                      query: {
                          loc: cityQ,
                          lat: data.latitude || undefined,
                          lng: data.longitude || undefined,
                      },
                  })
              ),
    },
    {
        title: 'dog hiking trails',
        count: data?.trailSpotsCount || 0,
        isSubPage: subHikingPage,
        link: subHikingPage
            ? RouteFormatter.listings({ first: subHikingPage.url })
            : encodeURI(
                  RouteFormatter.hikingListings(null, {
                      query: {
                          loc: cityQ,
                          lat: data.latitude || undefined,
                          lng: data.longitude || undefined,
                      },
                  })
              ),
    },
    {
        title: 'dog fields',
        count: data?.fieldSpotsCount || 0,
        isSubPage: subFieldPage,
        link: subFieldPage
            ? RouteFormatter.listings({ first: subFieldPage.url })
            : encodeURI(
                  RouteFormatter.fieldsListings(null, {
                      query: {
                          loc: cityQ,
                          lat: data.latitude || undefined,
                          lng: data.longitude || undefined,
                      },
                  })
              ),
    },
    {
        title: 'dog agility parks',
        count: data?.agilitySpotsCount || 0,
        isSubPage: subAgilityPage,
        link: subAgilityPage
            ? RouteFormatter.listings({ first: subAgilityPage.url })
            : encodeURI(
                  RouteFormatter.agilityListings(null, {
                      query: {
                          loc: cityQ,
                          lat: data.latitude || undefined,
                          lng: data.longitude || undefined,
                      },
                  })
              ),
    },
    {
        title: 'small dog parks',
        count: data?.smallDogSpotsCount || 0,
        isSubPage: subSmallPage,
        link: subSmallPage
            ? RouteFormatter.listings({ first: subSmallPage.url })
            : encodeURI(
                  RouteFormatter.smallDogListings(null, {
                      query: {
                          loc: cityQ,
                          lat: data.latitude || undefined,
                          lng: data.longitude || undefined,
                      },
                  })
              ),
    },
    {
        title: 'dog beaches',
        count: data?.beachSpotsCount || 0,
        isSubPage: subBeachPage,
        link: subBeachPage
            ? RouteFormatter.listings({ first: subBeachPage.url })
            : encodeURI(
                  RouteFormatter.beachListings(null, {
                      query: {
                          loc: cityQ,
                          lat: data.latitude || undefined,
                          lng: data.longitude || undefined,
                      },
                  })
              ),
    },
    {
        title: 'dog indoor spaces',
        count: data?.indoorSpotsCount || 0,
        isSubPage: subIndoorPage,
        link: subIndoorPage
            ? RouteFormatter.listings({ first: subIndoorPage.url })
            : encodeURI(
                  RouteFormatter.indoorListings(null, {
                      query: {
                          loc: cityQ,
                          lat: data.latitude || undefined,
                          lng: data.longitude || undefined,
                      },
                  })
              ),
    },
];

const RenderWhyRent = ({ data, subObj }) => {
    const isNeighborhood = data?.pageType === 'NEIGHBORHOOD';
    const cityQ = encodeURI(`${data.name}, ${data.state}`);
    const whyRent = isNeighborhood
        ? `Why rent a private dog park in ${data.name}, ${data.city}, ${data.stateShort || data.state}?`
        : `Why rent a private ${subObj?.seoTitle.toLowerCase() || 'dog park'} in ${data.name}, ${data.state}?`;
    const subWaterPage = data.subpages?.find((s) => s.pageType === 'DOG_WATER_PARKS');
    const subFencedPage = data.subpages?.find((s) => s.pageType === 'FULLY_FENCED_DOG_PARKS');
    const subHikingPage = data.subpages?.find((s) => s.pageType === 'DOG_HIKING_TRAILS');
    const subAgilityPage = data.subpages?.find((s) => s.pageType === 'DOG_AGILITY_PARKS');
    const subFieldPage = data.subpages?.find((s) => s.pageType === 'DOG_FIELDS');
    const subSmallPage = data.subpages?.find((s) => s.pageType === 'SMALL_DOG_PARKS');
    const subBeachPage = data.subpages?.find((s) => s.pageType === 'DOG_BEACHES');
    const subIndoorPage = data.subpages?.find((s) => s.pageType === 'INDOOR_DOG_PARKS');

    const filteredStats = stats({
        data,
        cityQ,
        subWaterPage,
        subFencedPage,
        subHikingPage,
        subAgilityPage,
        subFieldPage,
        subSmallPage,
        subBeachPage,
        subIndoorPage,
    }).filter((s) => s.count >= MIN_SPOTS_APPEREANCES);

    return (
        <div className="sniff-rent-private">
            <div className="l-container">
                <h2 className="snif-m1 snif-l1-pc snif-semibold mb-3">{whyRent}</h2>
                {!subObj && filteredStats.length >= MIN_STATS_SHOWN && (
                    <div className="sniff-stats">
                        {filteredStats.slice(0, MAX_STATS_SHOWN).map((s, i) => (
                            <a key={i} href={s.link} target="_blank" rel={s.isSubPage ? 'noreferrer' : 'noreferrer nofollow'}>
                                <div className="snif-l2 snif-xl-pc snif-bold text-primary mb-05">{s.count}</div>
                                <div className="snif-s2 snif-s1-pc snif-medium">{s.title}</div>
                            </a>
                        ))}
                    </div>
                )}
                <div className="rent-private-tbl">
                    <table>
                        <thead>
                            <tr>
                                <th>Features</th>
                                <th>Sniffspot</th>
                                <th>Public park</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className="tbl-tl">Designed for private play</td>
                                <td className="text-center text-primary">
                                    <SvgCheck />
                                </td>
                                <td className="text-center text-danger tbl-tr">
                                    <SvgCross />
                                </td>
                            </tr>
                            <tr>
                                <td>Rentable by the hour</td>
                                <td className="text-center text-primary">
                                    <SvgCheck />
                                </td>
                                <td className="text-center text-danger">
                                    <SvgCross />
                                </td>
                            </tr>
                            <tr>
                                <td>Off leash options</td>
                                <td className="text-center text-primary">
                                    <SvgCheck />
                                </td>
                                <td className="text-center text-danger">
                                    <SvgCross />
                                </td>
                            </tr>
                            <tr>
                                <td className="tbl-bl">Very large and/or fully fenced options</td>
                                <td className="text-center text-primary">
                                    <SvgCheck />
                                </td>
                                <td className="text-center text-danger tbl-br">
                                    <SvgCross />
                                </td>
                            </tr>
                            <tr>
                                <td>Pricing</td>
                                <td className="snif-s2 snif-p-pc text-center">
                                    Avg 10-20 credits per visit -{' '}
                                    <a
                                        href={RouteFormatter.subscriptionsNew(null, { query: { src: SPOT_SRC_MEMBERSHIP.WEB_WHY_RENT_LEARN_MORE } })}
                                        title="Learn more about membership"
                                    >
                                        learn more
                                    </a>
                                </td>
                                <td className="text-center">Free</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default RenderWhyRent;
